var _rect, _circle, _circle2, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgElderly(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 120 120",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 120,
    rx: 30,
    fill: "#FFF4EF"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 43,
    cy: 43,
    r: 15,
    fill: "#FFD1BB"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 78,
    cy: 43,
    r: 15,
    fill: "#FFD1BB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28 98c1-27 10-40 25-40s22 14 22 40",
    fill: "#6EA6D8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M60 98c1-27 10-40 25-40 12 0 19 14 20 40",
    fill: "#E89A60"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35 35c6-15 22-13 25 0M70 35c6-15 22-13 25 0",
    fill: "none",
    stroke: "#E8E8E8",
    strokeWidth: 8,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgElderly);
export default __webpack_public_path__ + "static/media/elderly.89953ea081d643fb0672bb61ab14af86.svg";
export { ForwardRef as ReactComponent };